import { gql } from '@apollo/client'

export const LEAVE_FEEDBACK_MUTATION = gql`
    mutation ($feedback: String!) {
        leaveFeedback(feedback: $feedback) {
            code
        }
    }
`
